import * as React from 'react';
import clsx from 'clsx';

import styles from '../ProductDetailsView.module.css';

export interface TabPane {
  header: string;
  content: React.ElementType;
}

interface Props {
  panes: TabPane[];
}

export const ProductOutlineTabs = ({ panes }: Props) => {
  const [activeIndex, setActiveIndex] = React.useState(0);

  return (
    <>
      <ul className={styles['overview__tab']}>
        {panes.map((pane, idx) => {
          return (
            <li
              key={pane.header}
              className={clsx(idx === activeIndex && styles['is-active'])}
              onClick={() => setActiveIndex(idx)}
            >
              <a>{pane.header}</a>
            </li>
          );
        })}
      </ul>
      {panes.map((pane, idx) => {
        const Content = pane.content;
        return (
          <ul key={pane.header} className={styles['overview__content']}>
            <li
              className={clsx(
                styles['overview__content__item'],
                idx === activeIndex && styles['is-active']
              )}
            >
              <Content />
            </li>
          </ul>
        );
      })}
    </>
  );
};
